//components
import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/modal';
import ImageGallery from '../../components/imageGallery';
import { themePropType } from '../../components/sharedPropTypes';
import { getImagePaths, loadImages } from '../../utils/imageLoader';

const Figurines = ({ theme }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [figureImages, setFigureImages] = useState([]);
    
    //For dynamic imports (better for code splitting)
    useEffect(() => {
      const loadCollectionImages = async () => {
        const images = await loadImages('figurines');
        setFigureImages(images);
      };
      loadCollectionImages();
    }, []);
    return (
      <div className='figurinesPage'>
        <h3>Figurines and other similar collectibles</h3>
        <p>I'm gonna count anything that's not plushie related and shaped like a little guy as a figurine.</p>
        <ImageGallery
          images={figureImages}
          onImageClick={setSelectedImage}
        />
        <CustomModal
          isOpen={!!selectedImage}
          onRequestClose={() => setSelectedImage(null)}
          theme={theme}
        >
          {selectedImage && (
            <img 
              src={selectedImage} 
              style={{ maxWidth: '100%', maxHeight: '80vh' }} 
              alt="Enlarged figurine" 
            />
          )}
        </CustomModal>
      </div>
    );
  };
  Figurines.propTypes = {
    theme: themePropType
  };
  export default Figurines;